export const rubrosHistoricos = [
      {
        "anio": "2025",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../zip/2025/1erTrimestreOM2025.zip"
            },
           {
                "trimestre": "Segundo Trimestre",
                "url": "../zip/2025/2doTrimestreOM2025.zip"
            },
        
           
        ]
    }, 


     {
        "anio": "2024",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../zip/2024/1er.TrimestreOM.zip"
            },
            {
                "trimestre": "Segundo Trimestre",
                "url": "../zip/2024/2do.TrimestreOM.zip"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../zip/2024/3er.TrimestreOM.zip"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../zip/2024/4to.TrimestreOM.zip"
            },
           
        ]
    }, 


    {
        "anio": "2023",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../zip/2023/1er.TrimestreOM.zip"
            },
            {
                "trimestre": "Segundo Trimestre",
                "url": "../zip/2023/2do.TrimestreOM.zip"
            }
            ,
            {
                "trimestre": "Tercer Trimestre",
                "url": "../zip/2023/3er.TrimestreOM.zip"
            }
            ,
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../zip/2023/4to.TrimestreOM.zip"
            }
        ]
    },
    {
        "anio": "2022",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../zip/2022/1er.TrimestreOM.zip"
            },
            {
                "trimestre": "Segundo Trimestre",
                "url": "../zip/2022/2do.TrimestreOM.zip"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../zip/2022/3er.TrimestreOM.zip"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../zip/2022/4to.TrimestreOM.zip"
            }
        ]
    },
    {
        "anio": "2021",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../zip/2021/1er.TrimestreOM.zip"
            },
            {
                "trimestre": "Segundo Trimestre",
                "url": "../zip/2021/2do.TrimestreOM.zip"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../zip/2021/3er.TrimestreOM.zip"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../zip/2021/4to.TrimestreOM.zip"
            }
        ]
    },
    {
        "anio": "2020",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../zip/2020/1er.TrimestreOM.zip"
            },
            {
                "trimestre": "Segundo Trimestre",
                "url": "../zip/2020/2do.TrimestreOM.zip"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../zip/2020/3er.TrimestreOM.zip"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../zip/2020/4to.TrimestreOM.zip"
            }
        ]
    },
    {
        "anio": "2019",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../zip/2019/1er.TrimestreOM.zip"
            },
            {
                "trimestre": "Segundo Trimestre",
                "url": "../zip/2019/2do.TrimestreOM.zip"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../zip/2019/3er.TrimestreOM.zip"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../zip/2019/4to.TrimestreOM.zip"
            }
        ]
    },
    {
        "anio": "2018",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../zip/2018/1er.TrimestreOM.zip"
            },
            {
                "trimestre": "Segundo Trimestre",
                "url": "../zip/2018/2do.TrimestreOM.zip"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../zip/2018/3er.TrimestreOM.zip"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../zip/2018/4to.TrimestreOM.zip"
            }
        ]
    },
    {
        "anio": "2015 - 2017",
        "descripcion": "Ejercicios Anteriores",
        "trimestres": [
            {
                "trimestre": "Plataforma Nacional",
                "url": "https://consultapublicamx.plataformadetransparencia.org.mx/vut-web/faces/view/consultaPublica.xhtml?idEntidad=MTM=&idSujetoObligado=MjEzMQ=="
            }
        ]
    },
    

]